import AnimateText from '@/components/AnimateText/AnimateText'
import Header from '@/components/Layout/Header'
import { PrivateRoutes, PublicRoutes } from '@/constants/routes'
import { IConfigSeller } from '@/models/configSeller'
import { IUser } from '@/models/user.model'
import { terms } from '@/utils/terms'
import { Button, Link } from '@nextui-org/react'
import { motion } from 'framer-motion'
import { CSSProperties } from 'react'
import { MdArrowForward, MdCheckCircleOutline } from 'react-icons/md'
import { useSelector } from 'react-redux'
import { useLocation, useParams } from 'react-router-dom'

const SuccessPage = () => {
  const { slug } = useParams()
  const configSeller = useSelector((store: { config: IConfigSeller }) => store.config)
  const userState = useSelector((store: { user: IUser }) => store.user)
  const location = useLocation()

  return (
    <motion.div
      initial={{ y: 10, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      exit={{ y: -10, opacity: 0 }}
      transition={{ duration: 0.3 }} className='flex flex-col h-full min-h-screen'
    >
      {configSeller.config.s3.FOLDER_APP === 'ti_macstore' && userState.id !== 0 &&
        <Header />}
      <header className='py-4 container  max-w-[1100px] mb-4 mx-auto px-4 md:px-0'>
        <AnimateText text='¡Tu cotización ha sido exitosa!' className='text-4xl font-bold mb-5' />
      </header>
      <section className='container mx-auto max-w-[1100px]'>
        {
          (configSeller.config.s3.FOLDER_APP === 'ti_falabella')
            ? (
              <div className='px-4 md:px-2 xl:px-0 grid grid-cols-1 gap-4 md:grid-cols-2 lg:grid-cols-4' style={{ '--seller-color': `${configSeller.config.color}` } as CSSProperties}>
                <div className='md:col-span-2 lg:col-span-4'>Asegúrate de revisar tu mail y seguir estos pasos antes de acudir a la tienda adherida más cercana</div>
                <div className='max-w-md mx-auto p-6 bg-white border border-gray-200 rounded-lg shadow-sm dark:bg-gray-800 dark:border-gray-700'>
                  <div className='w-10 bg-[var(--seller-color)] rounded-full h-10 flex items-center justify-center mb-2'><span className='font-bold'>1</span></div>
                  <a href='#'>
                    <h5 className='mb-2 text-xl font-semibold tracking-tight text-gray-900 dark:text-white'>Respalda tu información personal</h5>
                  </a>
                  <p className='mb-3 font-normal text-gray-500 dark:text-gray-400'>Respalda tu información, fotos, chats, pero sin resetear el equipo ya que en tienda revisarán ciertas funcionalidades. No olvides cerrar tu sesión icloud o Android.</p>
                </div>
                <div className='max-w-md mx-auto p-6 bg-white border border-gray-200 rounded-lg shadow-sm dark:bg-gray-800 dark:border-gray-700'>
                  <div className='w-10 bg-[var(--seller-color)] rounded-full h-10 flex items-center justify-center mb-2'><span className='font-bold'>2</span></div>
                  <a href='#'>
                    <h5 className='mb-2 text-xl font-semibold tracking-tight text-gray-900 dark:text-white'>Lleva los accesorios del equipo</h5>
                  </a>
                  <p className='mb-3 font-normal text-gray-500 dark:text-gray-400'>En caso de entregar un notebook o smartwatch, debes entregar el cargador. En el caso de un celular y tablet, no es necesario. Recuerda traer la batería cargada.</p>
                </div>
                <div className='max-w-md mx-auto p-6 bg-white border border-gray-200 rounded-lg shadow-sm dark:bg-gray-800 dark:border-gray-700'>
                  <div className='w-10 bg-[var(--seller-color)] rounded-full h-10 flex items-center justify-center mb-2'><span className='font-bold'>3</span></div>
                  <a href='#'>
                    <h5 className='mb-2 text-xl font-semibold tracking-tight text-gray-900 dark:text-white'>Descarga la App Phonechek</h5>
                  </a>
                  <p className='mb-3 font-normal text-gray-500 dark:text-gray-400'>Si cotizaste un smartphone, descarga la App Phonechek, la necesitarás en la tienda. url app: </p>
                  <div className='flex flex-col gap-2'>
                    <a href='https://apps.apple.com/cl/app/phonecheck/id1446390777' target='_blank' className='w-full max-w-[250px] min-w-[180px] mx-auto sm:w-auto bg-gray-800 hover:bg-gray-700 focus:ring-4 focus:outline-none focus:ring-gray-300 text-white rounded-lg inline-flex items-center justify-center px-4 py-2.5 dark:bg-gray-700 dark:hover:bg-gray-600 dark:focus:ring-gray-700' rel='noreferrer'>
                      <svg className='me-3 w-7 h-7' aria-hidden='true' focusable='false' data-prefix='fab' data-icon='apple' role='img' xmlns='http://www.w3.org/2000/svg' viewBox='0 0 384 512'><path fill='currentColor' d='M318.7 268.7c-.2-36.7 16.4-64.4 50-84.8-18.8-26.9-47.2-41.7-84.7-44.6-35.5-2.8-74.3 20.7-88.5 20.7-15 0-49.4-19.7-76.4-19.7C63.3 141.2 4 184.8 4 273.5q0 39.3 14.4 81.2c12.8 36.7 59 126.7 107.2 125.2 25.2-.6 43-17.9 75.8-17.9 31.8 0 48.3 17.9 76.4 17.9 48.6-.7 90.4-82.5 102.6-119.3-65.2-30.7-61.7-90-61.7-91.9zm-56.6-164.2c27.3-32.4 24.8-61.9 24-72.5-24.1 1.4-52 16.4-67.9 34.9-17.5 19.8-27.8 44.3-25.6 71.9 26.1 2 49.9-11.4 69.5-34.3z' /></svg>
                      <div className='text-left rtl:text-right'>
                        <div className='mb-1 text-xs'>Download on the</div>
                        <div className='-mt-1 font-sans text-sm font-semibold'>Mac App Store</div>
                      </div>
                    </a>
                    <a href='https://play.google.com/store/apps/details?id=com.phonecheck.phonecheckconsumer&pcampaignid=web_share' target='_blank' className='w-full max-w-[250px] min-w-[180px] mx-auto sm:w-auto bg-gray-800 hover:bg-gray-700 focus:ring-4 focus:outline-none focus:ring-gray-300 text-white rounded-lg inline-flex items-center justify-center px-4 py-2.5 dark:bg-gray-700 dark:hover:bg-gray-600 dark:focus:ring-gray-700' rel='noreferrer'>
                      <svg className='me-3 w-7 h-7' aria-hidden='true' focusable='false' data-prefix='fab' data-icon='google-play' role='img' xmlns='http://www.w3.org/2000/svg' viewBox='0 0 512 512'><path fill='currentColor' d='M325.3 234.3L104.6 13l280.8 161.2-60.1 60.1zM47 0C34 6.8 25.3 19.2 25.3 35.3v441.3c0 16.1 8.7 28.5 21.7 35.3l256.6-256L47 0zm425.2 225.6l-58.9-34.1-65.7 64.5 65.7 64.5 60.1-34.1c18-14.3 18-46.5-1.2-60.8zM104.6 499l280.8-161.2-60.1-60.1L104.6 499z' /></svg>
                      <div className='text-left rtl:text-right'>
                        <div className='mb-1 text-xs'>Get in on</div>
                        <div className='-mt-1 font-sans text-sm font-semibold'>Google Play</div>
                      </div>
                    </a>
                  </div>

                </div>
                <div className='max-w-md mx-auto p-6 bg-white border border-gray-200 rounded-lg shadow-sm dark:bg-gray-800 dark:border-gray-700'>
                  <div className='w-10 bg-[var(--seller-color)] rounded-full h-10 flex items-center justify-center mb-2'><span className='font-bold'>4</span></div>
                  <a href='#'>
                    <h5 className='mb-2 text-xl font-semibold tracking-tight text-gray-900 dark:text-white'>Acércate a la tienda adherida más cercana</h5>
                  </a>
                  <p className='mb-3 font-normal text-gray-500 dark:text-gray-400'>Un ejecuivo evaluará el estado real del equipo en la tienda. Si cumples con las condiciones tu GC digital que podrás utilizar en Falabella y Falabella.com</p>
                </div>
              </div>
              )
            : (
              <div className='border-1 border-[#43A047] p-3 rounded-md bg-[#EEFFEF]'>
                <div className='flex'>
                  <div className='px-2 pt-[2px]'>
                    <MdCheckCircleOutline className='text-xl text-[#43A047] ' />
                  </div>
                  <div className='col-span-11'>
                    <p className='font-bold'>Tus siguientes pasos:</p>
                    <ul className='list-disc ps-4 pt-2'>
                      <li>Revisa tu correo electrónico y sigue las instrucciones</li>
                    </ul>
                  </div>
                </div>
              </div>
              )
        }

        {configSeller.config.terms !== undefined &&
          configSeller.config.terms !== '' &&
          slug === 'falabella' &&
          terms(configSeller.config.terms, false)}
      </section>
      <footer>
        <div className='container mx-auto text-center max-w-[1100px]'>
          <div className='text-end mt-4'>
            <Button
              as={Link}
              className='rounded-full bg-black text-white disabled:bg-gray-300 disabled:border-gray-300 border-1 py-6 px-10'
              href={location.pathname.includes('backoffice') ? PrivateRoutes.FORMULARIO.replace(':slug', String(slug)) : PublicRoutes.SLUG.replace(':slug', String(slug))}
              endContent={<MdArrowForward />}
            >
              Realiza una nueva preevaluación
            </Button>
          </div>
        </div>
      </footer>
    </motion.div>
  )
}

export default SuccessPage
